<div class="card" id="payment-promises{{key}}">
  <div class="card-body">
    <div class="title-bar">
      <h2 class="card-title">Promises</h2>

      @if (contactId && (contactId > 0) && insight && insight.count) {
        <form [formGroup]="form">
          <div class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="show-all-switch" formControlName="all">
            <label class="custom-control-label" for="show-all-switch">Show history</label>
          </div>
        </form>
      }

      @if ((contactId && (contactId > 0)) || (saleId && (saleId > 0))) {
        <div class="dropdown">
          <button class="btn btn-sm btn-primary dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" [disabled]="!creatable" aria-expanded="false">
            <span class="uil-plus"></span>
          </button>
          <div class="dropdown-menu">
            @for (sale of promisable; track sale) {
              <div class="dropdown-item" (click)="create($event, sale)">
                @if (!sale.url) {
                  <span class="material-icons">{{icon(null)}}</span>
                }
                @if (sale.url) {
                  <img [src]="sale.url" [alt]="sale.vehicle || null" />
                }
                <p class="due {{dueToClass(sale.due)}}">{{sale.due | date:'MMM d, yy'}}</p>
                <div class="currency"><p class="title">{{sale.amount | currency}}</p></div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
  <ul class="list-group list-group-flush promise-list">
    @if ((!promises || (promises.length <= 0))) {
      <li class="list-group-item">No payment promises at this time.</li>
    }
    @for (promise of promises; track promise) {
      <li class="list-group-item {{(promise.closed || promise.broken) ? 'closed' : 'open'}}" (click)="selected($event, promise)">
        @if (!promise.url) {
          <span class="material-icons">handshake</span>
        }
        @if (promise.url) {
          <img [src]="promise.url" />
        }
        <p class="due {{promise.broken ? 'text-danger' : ''}}">{{promise.due | date:'M/d'}}</p>
        <div class="text-truncate">
          @if (!contactId || (contactId <= 0)) {
            <p class="title">{{promise.contact}}</p>
          }
          @if (contactId && (contactId > 0)) {
            <p class="title">{{promise.stock}} {{promise.vehicle}}</p>
          }
          @if (!promise.closed && !promise.broken) {
            <p class="subtitle">{{promise.note || 'No note provided'}} - {{promise.user}}</p>
          }
          @if (promise.broken && !promise.closed) {
            <p class="subtitle"><span class="text-danger material-icons">broken_image</span> Due date has passed with promise unfulfilled</p>
          }
          @if (promise.closed) {
            <p class="subtitle"><span class="text-success material-icons">check_circle</span> Fulfilled promise on {{promise.fulfilled | date:'M/d/yy'}}</p>
          }
        </div>
        <div class="currency">
          <p>{{promise.owed | currency}}</p>
          @if (promise.paid > 0) {
            <p class="subtitle">paid {{promise.paid | currency}}</p>
          }
        </div>
      </li>
    }
  </ul>
  @if (insight && insight.count) {
    <div class="card-footer text-muted">
      <span class="material-icons text-warning">tips_and_updates</span>
      <p>
        {{insight.name}} has fulfilled their promises <strong>{{insight.percent_fulfilled | number:'1.0-0'}}%</strong> of the time.
        They have promised to pay {{insight.promised | currency}} and have paid {{insight.paid | currency}}, or <strong>{{insight.percent_paid | number:'1.0-0'}}%</strong>, of that amount.
      </p>
    </div>
  }
</div>

<button id="togglePayPromiseEdit{{key}}" [attr.data-target]="'#editPayPromisesModal' + key" data-toggle="modal" class="d-none"></button>
<div class="modal fade" data-backdrop="static" id="editPayPromisesModal{{key}}" tabindex="-1" role="dialog" aria-labelledby="editPromise">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <promise-edit [sale]="editSale" (edited)="promisesEdited($event)"></promise-edit>
      </div>
    </div>
  </div>
</div>